module.exports = __webpack_public_path__ + "img/u2464.08166b67.png";